/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  DocumentReadDataList
} from '../../model/documentReadDataList'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  InvestorEntityDataList
} from '../../model/investorEntityDataList'
import type {
  InvestorTransferDocumentReadDataList
} from '../../model/investorTransferDocumentReadDataList'
import type {
  InvestorTransferDocumentsCreateListDataRequest
} from '../../model/investorTransferDocumentsCreateListDataRequest'
import type {
  InvestorTransferReadData
} from '../../model/investorTransferReadData'
import type {
  InvestorTransferUpsertDataRequest
} from '../../model/investorTransferUpsertDataRequest'
import type {
  InvestorTransfereeEntityReadDataList
} from '../../model/investorTransfereeEntityReadDataList'
import type {
  InvestorTransfereeEntityUpsertListDataRequest
} from '../../model/investorTransfereeEntityUpsertListDataRequest'
import type {
  InvestorTransfereeReadDataList
} from '../../model/investorTransfereeReadDataList'
import type {
  InvestorTransferorReadInformationDataList
} from '../../model/investorTransferorReadInformationDataList'
import type {
  TransferInvestorEntitySummaryTableDataRetrieveParams
} from '../../model/transferInvestorEntitySummaryTableDataRetrieveParams'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Upsert an investor transfer.
 */
export const investorTransferUpsert = (
    fundFamilyId: string,
    investorTransferUpsertDataRequest: InvestorTransferUpsertDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<InvestorTransferReadData>(
      {url: `/fund-family/${fundFamilyId}/investor-transfer/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: investorTransferUpsertDataRequest
    },
      options);
    }
  


export const getInvestorTransferUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorTransferUpsert>>, TError,{fundFamilyId: string;data: InvestorTransferUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investorTransferUpsert>>, TError,{fundFamilyId: string;data: InvestorTransferUpsertDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investorTransferUpsert>>, {fundFamilyId: string;data: InvestorTransferUpsertDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  investorTransferUpsert(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestorTransferUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof investorTransferUpsert>>>
    export type InvestorTransferUpsertMutationBody = InvestorTransferUpsertDataRequest
    export type InvestorTransferUpsertMutationError = unknown

    export const useInvestorTransferUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorTransferUpsert>>, TError,{fundFamilyId: string;data: InvestorTransferUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestorTransferUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get an investor transfer.
 */
export const investorTransferRetrieve = (
    fundFamilyId: string,
    investorTransferId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<InvestorTransferReadData>(
      {url: `/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getInvestorTransferRetrieveQueryKey = (fundFamilyId: string,
    investorTransferId: string,) => {
    return [`/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/`] as const;
    }

    
export const getInvestorTransferRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof investorTransferRetrieve>>, TError = unknown>(fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorTransferRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorTransferRetrieveQueryKey(fundFamilyId,investorTransferId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorTransferRetrieve>>> = ({ signal }) => investorTransferRetrieve(fundFamilyId,investorTransferId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && investorTransferId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investorTransferRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorTransferRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof investorTransferRetrieve>>>
export type InvestorTransferRetrieveQueryError = unknown

export const useInvestorTransferRetrieve = <TData = Awaited<ReturnType<typeof investorTransferRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorTransferRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorTransferRetrieveQueryOptions(fundFamilyId,investorTransferId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestorTransferRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investorTransferRetrieve>>, TError = unknown>(fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransferRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorTransferRetrieveQueryKey(fundFamilyId,investorTransferId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorTransferRetrieve>>> = ({ signal }) => investorTransferRetrieve(fundFamilyId,investorTransferId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && investorTransferId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransferRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorTransferRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investorTransferRetrieve>>>
export type InvestorTransferRetrieveSuspenseQueryError = unknown

export const useInvestorTransferRetrieveSuspense = <TData = Awaited<ReturnType<typeof investorTransferRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransferRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorTransferRetrieveSuspenseQueryOptions(fundFamilyId,investorTransferId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestorTransferRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,investorTransferId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,investorTransferId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && investorTransferId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestorTransferRetrieveQueryKey(fundFamilyId,investorTransferId),
              queryFn: () => investorTransferRetrieve(fundFamilyId,investorTransferId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Delete an investor transfer.
 */
export const investorTransferDestroy = (
    fundFamilyId: string,
    investorTransferId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/`, method: 'DELETE'
    },
      options);
    }
  


export const getInvestorTransferDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorTransferDestroy>>, TError,{fundFamilyId: string;investorTransferId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investorTransferDestroy>>, TError,{fundFamilyId: string;investorTransferId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investorTransferDestroy>>, {fundFamilyId: string;investorTransferId: string}> = (props) => {
          const {fundFamilyId,investorTransferId} = props ?? {};

          return  investorTransferDestroy(fundFamilyId,investorTransferId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestorTransferDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof investorTransferDestroy>>>
    
    export type InvestorTransferDestroyMutationError = unknown

    export const useInvestorTransferDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorTransferDestroy>>, TError,{fundFamilyId: string;investorTransferId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestorTransferDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Complete an investor transfer.
 */
export const investorTransferComplete = (
    fundFamilyId: string,
    investorTransferId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/complete/`, method: 'PATCH'
    },
      options);
    }
  


export const getInvestorTransferCompleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorTransferComplete>>, TError,{fundFamilyId: string;investorTransferId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investorTransferComplete>>, TError,{fundFamilyId: string;investorTransferId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investorTransferComplete>>, {fundFamilyId: string;investorTransferId: string}> = (props) => {
          const {fundFamilyId,investorTransferId} = props ?? {};

          return  investorTransferComplete(fundFamilyId,investorTransferId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestorTransferCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof investorTransferComplete>>>
    
    export type InvestorTransferCompleteMutationError = unknown

    export const useInvestorTransferComplete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorTransferComplete>>, TError,{fundFamilyId: string;investorTransferId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestorTransferCompleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * List all Investor Transfer Documents
 */
export const investorTransferDocumentsList = (
    fundFamilyId: string,
    investorTransferId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<DocumentReadDataList>(
      {url: `/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/document/`, method: 'GET', signal
    },
      options);
    }
  

export const getInvestorTransferDocumentsListQueryKey = (fundFamilyId: string,
    investorTransferId: string,) => {
    return [`/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/document/`] as const;
    }

    
export const getInvestorTransferDocumentsListQueryOptions = <TData = Awaited<ReturnType<typeof investorTransferDocumentsList>>, TError = unknown>(fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorTransferDocumentsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorTransferDocumentsListQueryKey(fundFamilyId,investorTransferId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorTransferDocumentsList>>> = ({ signal }) => investorTransferDocumentsList(fundFamilyId,investorTransferId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && investorTransferId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investorTransferDocumentsList>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorTransferDocumentsListQueryResult = NonNullable<Awaited<ReturnType<typeof investorTransferDocumentsList>>>
export type InvestorTransferDocumentsListQueryError = unknown

export const useInvestorTransferDocumentsList = <TData = Awaited<ReturnType<typeof investorTransferDocumentsList>>, TError = unknown>(
 fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorTransferDocumentsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorTransferDocumentsListQueryOptions(fundFamilyId,investorTransferId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestorTransferDocumentsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investorTransferDocumentsList>>, TError = unknown>(fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransferDocumentsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorTransferDocumentsListQueryKey(fundFamilyId,investorTransferId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorTransferDocumentsList>>> = ({ signal }) => investorTransferDocumentsList(fundFamilyId,investorTransferId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && investorTransferId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransferDocumentsList>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorTransferDocumentsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investorTransferDocumentsList>>>
export type InvestorTransferDocumentsListSuspenseQueryError = unknown

export const useInvestorTransferDocumentsListSuspense = <TData = Awaited<ReturnType<typeof investorTransferDocumentsList>>, TError = unknown>(
 fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransferDocumentsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorTransferDocumentsListSuspenseQueryOptions(fundFamilyId,investorTransferId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestorTransferDocumentsListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,investorTransferId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,investorTransferId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && investorTransferId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestorTransferDocumentsListQueryKey(fundFamilyId,investorTransferId),
              queryFn: () => investorTransferDocumentsList(fundFamilyId,investorTransferId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Create a list of Investor Transfer Documents
 */
export const investorTransferDocumentsCreate = (
    fundFamilyId: string,
    investorTransferId: string,
    investorTransferDocumentsCreateListDataRequest: InvestorTransferDocumentsCreateListDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<InvestorTransferDocumentReadDataList>(
      {url: `/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/document/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: investorTransferDocumentsCreateListDataRequest
    },
      options);
    }
  


export const getInvestorTransferDocumentsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorTransferDocumentsCreate>>, TError,{fundFamilyId: string;investorTransferId: string;data: InvestorTransferDocumentsCreateListDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investorTransferDocumentsCreate>>, TError,{fundFamilyId: string;investorTransferId: string;data: InvestorTransferDocumentsCreateListDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investorTransferDocumentsCreate>>, {fundFamilyId: string;investorTransferId: string;data: InvestorTransferDocumentsCreateListDataRequest}> = (props) => {
          const {fundFamilyId,investorTransferId,data} = props ?? {};

          return  investorTransferDocumentsCreate(fundFamilyId,investorTransferId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestorTransferDocumentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof investorTransferDocumentsCreate>>>
    export type InvestorTransferDocumentsCreateMutationBody = InvestorTransferDocumentsCreateListDataRequest
    export type InvestorTransferDocumentsCreateMutationError = unknown

    export const useInvestorTransferDocumentsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorTransferDocumentsCreate>>, TError,{fundFamilyId: string;investorTransferId: string;data: InvestorTransferDocumentsCreateListDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestorTransferDocumentsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * List investor transferee entities for a transfer.
 */
export const investorTransfereeEntitiesList = (
    fundFamilyId: string,
    investorTransferId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<InvestorTransfereeEntityReadDataList>(
      {url: `/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/investor-transferee-entities/`, method: 'GET', signal
    },
      options);
    }
  

export const getInvestorTransfereeEntitiesListQueryKey = (fundFamilyId: string,
    investorTransferId: string,) => {
    return [`/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/investor-transferee-entities/`] as const;
    }

    
export const getInvestorTransfereeEntitiesListQueryOptions = <TData = Awaited<ReturnType<typeof investorTransfereeEntitiesList>>, TError = unknown>(fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorTransfereeEntitiesList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorTransfereeEntitiesListQueryKey(fundFamilyId,investorTransferId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorTransfereeEntitiesList>>> = ({ signal }) => investorTransfereeEntitiesList(fundFamilyId,investorTransferId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && investorTransferId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investorTransfereeEntitiesList>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorTransfereeEntitiesListQueryResult = NonNullable<Awaited<ReturnType<typeof investorTransfereeEntitiesList>>>
export type InvestorTransfereeEntitiesListQueryError = unknown

export const useInvestorTransfereeEntitiesList = <TData = Awaited<ReturnType<typeof investorTransfereeEntitiesList>>, TError = unknown>(
 fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorTransfereeEntitiesList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorTransfereeEntitiesListQueryOptions(fundFamilyId,investorTransferId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestorTransfereeEntitiesListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investorTransfereeEntitiesList>>, TError = unknown>(fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransfereeEntitiesList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorTransfereeEntitiesListQueryKey(fundFamilyId,investorTransferId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorTransfereeEntitiesList>>> = ({ signal }) => investorTransfereeEntitiesList(fundFamilyId,investorTransferId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && investorTransferId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransfereeEntitiesList>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorTransfereeEntitiesListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investorTransfereeEntitiesList>>>
export type InvestorTransfereeEntitiesListSuspenseQueryError = unknown

export const useInvestorTransfereeEntitiesListSuspense = <TData = Awaited<ReturnType<typeof investorTransfereeEntitiesList>>, TError = unknown>(
 fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransfereeEntitiesList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorTransfereeEntitiesListSuspenseQueryOptions(fundFamilyId,investorTransferId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestorTransfereeEntitiesListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,investorTransferId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,investorTransferId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && investorTransferId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestorTransfereeEntitiesListQueryKey(fundFamilyId,investorTransferId),
              queryFn: () => investorTransfereeEntitiesList(fundFamilyId,investorTransferId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * List investor transferees.
 */
export const investorTransfereesList = (
    fundFamilyId: string,
    investorTransferId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<InvestorTransfereeReadDataList>(
      {url: `/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/investor-transferees/`, method: 'GET', signal
    },
      options);
    }
  

export const getInvestorTransfereesListQueryKey = (fundFamilyId: string,
    investorTransferId: string,) => {
    return [`/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/investor-transferees/`] as const;
    }

    
export const getInvestorTransfereesListQueryOptions = <TData = Awaited<ReturnType<typeof investorTransfereesList>>, TError = unknown>(fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorTransfereesList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorTransfereesListQueryKey(fundFamilyId,investorTransferId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorTransfereesList>>> = ({ signal }) => investorTransfereesList(fundFamilyId,investorTransferId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && investorTransferId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investorTransfereesList>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorTransfereesListQueryResult = NonNullable<Awaited<ReturnType<typeof investorTransfereesList>>>
export type InvestorTransfereesListQueryError = unknown

export const useInvestorTransfereesList = <TData = Awaited<ReturnType<typeof investorTransfereesList>>, TError = unknown>(
 fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorTransfereesList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorTransfereesListQueryOptions(fundFamilyId,investorTransferId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestorTransfereesListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investorTransfereesList>>, TError = unknown>(fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransfereesList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorTransfereesListQueryKey(fundFamilyId,investorTransferId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorTransfereesList>>> = ({ signal }) => investorTransfereesList(fundFamilyId,investorTransferId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && investorTransferId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransfereesList>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorTransfereesListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investorTransfereesList>>>
export type InvestorTransfereesListSuspenseQueryError = unknown

export const useInvestorTransfereesListSuspense = <TData = Awaited<ReturnType<typeof investorTransfereesList>>, TError = unknown>(
 fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransfereesList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorTransfereesListSuspenseQueryOptions(fundFamilyId,investorTransferId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestorTransfereesListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,investorTransferId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,investorTransferId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && investorTransferId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestorTransfereesListQueryKey(fundFamilyId,investorTransferId),
              queryFn: () => investorTransfereesList(fundFamilyId,investorTransferId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Upserts Investor Transferees for an Investor Transfer.
 */
export const investorTransfereesUpsert = (
    fundFamilyId: string,
    investorTransferId: string,
    investorTransfereeEntityUpsertListDataRequest: InvestorTransfereeEntityUpsertListDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<InvestorTransfereeReadDataList>(
      {url: `/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/investor-transferees/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: investorTransfereeEntityUpsertListDataRequest
    },
      options);
    }
  


export const getInvestorTransfereesUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorTransfereesUpsert>>, TError,{fundFamilyId: string;investorTransferId: string;data: InvestorTransfereeEntityUpsertListDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investorTransfereesUpsert>>, TError,{fundFamilyId: string;investorTransferId: string;data: InvestorTransfereeEntityUpsertListDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investorTransfereesUpsert>>, {fundFamilyId: string;investorTransferId: string;data: InvestorTransfereeEntityUpsertListDataRequest}> = (props) => {
          const {fundFamilyId,investorTransferId,data} = props ?? {};

          return  investorTransfereesUpsert(fundFamilyId,investorTransferId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestorTransfereesUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof investorTransfereesUpsert>>>
    export type InvestorTransfereesUpsertMutationBody = InvestorTransfereeEntityUpsertListDataRequest
    export type InvestorTransfereesUpsertMutationError = unknown

    export const useInvestorTransfereesUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorTransfereesUpsert>>, TError,{fundFamilyId: string;investorTransferId: string;data: InvestorTransfereeEntityUpsertListDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestorTransfereesUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * List investor transferor information for an investor transfer.
 */
export const investorTransferorsForInvestorTransferList = (
    fundFamilyId: string,
    investorTransferId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<InvestorTransferorReadInformationDataList>(
      {url: `/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/investor-transferors/`, method: 'GET', signal
    },
      options);
    }
  

export const getInvestorTransferorsForInvestorTransferListQueryKey = (fundFamilyId: string,
    investorTransferId: string,) => {
    return [`/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/investor-transferors/`] as const;
    }

    
export const getInvestorTransferorsForInvestorTransferListQueryOptions = <TData = Awaited<ReturnType<typeof investorTransferorsForInvestorTransferList>>, TError = unknown>(fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorTransferorsForInvestorTransferList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorTransferorsForInvestorTransferListQueryKey(fundFamilyId,investorTransferId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorTransferorsForInvestorTransferList>>> = ({ signal }) => investorTransferorsForInvestorTransferList(fundFamilyId,investorTransferId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && investorTransferId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investorTransferorsForInvestorTransferList>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorTransferorsForInvestorTransferListQueryResult = NonNullable<Awaited<ReturnType<typeof investorTransferorsForInvestorTransferList>>>
export type InvestorTransferorsForInvestorTransferListQueryError = unknown

export const useInvestorTransferorsForInvestorTransferList = <TData = Awaited<ReturnType<typeof investorTransferorsForInvestorTransferList>>, TError = unknown>(
 fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorTransferorsForInvestorTransferList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorTransferorsForInvestorTransferListQueryOptions(fundFamilyId,investorTransferId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestorTransferorsForInvestorTransferListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investorTransferorsForInvestorTransferList>>, TError = unknown>(fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransferorsForInvestorTransferList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorTransferorsForInvestorTransferListQueryKey(fundFamilyId,investorTransferId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorTransferorsForInvestorTransferList>>> = ({ signal }) => investorTransferorsForInvestorTransferList(fundFamilyId,investorTransferId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && investorTransferId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransferorsForInvestorTransferList>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorTransferorsForInvestorTransferListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investorTransferorsForInvestorTransferList>>>
export type InvestorTransferorsForInvestorTransferListSuspenseQueryError = unknown

export const useInvestorTransferorsForInvestorTransferListSuspense = <TData = Awaited<ReturnType<typeof investorTransferorsForInvestorTransferList>>, TError = unknown>(
 fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransferorsForInvestorTransferList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorTransferorsForInvestorTransferListSuspenseQueryOptions(fundFamilyId,investorTransferId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestorTransferorsForInvestorTransferListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,investorTransferId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,investorTransferId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && investorTransferId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestorTransferorsForInvestorTransferListQueryKey(fundFamilyId,investorTransferId),
              queryFn: () => investorTransferorsForInvestorTransferList(fundFamilyId,investorTransferId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get table data for allocation rules that are affected by an investor transfer.
 */
export const investorTransferReviewAllocationTableDataRetrieve = (
    fundFamilyId: string,
    investorTransferId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/review/allocations-table/`, method: 'GET', signal
    },
      options);
    }
  

export const getInvestorTransferReviewAllocationTableDataRetrieveQueryKey = (fundFamilyId: string,
    investorTransferId: string,) => {
    return [`/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/review/allocations-table/`] as const;
    }

    
export const getInvestorTransferReviewAllocationTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof investorTransferReviewAllocationTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorTransferReviewAllocationTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorTransferReviewAllocationTableDataRetrieveQueryKey(fundFamilyId,investorTransferId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorTransferReviewAllocationTableDataRetrieve>>> = ({ signal }) => investorTransferReviewAllocationTableDataRetrieve(fundFamilyId,investorTransferId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && investorTransferId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investorTransferReviewAllocationTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorTransferReviewAllocationTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof investorTransferReviewAllocationTableDataRetrieve>>>
export type InvestorTransferReviewAllocationTableDataRetrieveQueryError = unknown

export const useInvestorTransferReviewAllocationTableDataRetrieve = <TData = Awaited<ReturnType<typeof investorTransferReviewAllocationTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorTransferReviewAllocationTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorTransferReviewAllocationTableDataRetrieveQueryOptions(fundFamilyId,investorTransferId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestorTransferReviewAllocationTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investorTransferReviewAllocationTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransferReviewAllocationTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorTransferReviewAllocationTableDataRetrieveQueryKey(fundFamilyId,investorTransferId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorTransferReviewAllocationTableDataRetrieve>>> = ({ signal }) => investorTransferReviewAllocationTableDataRetrieve(fundFamilyId,investorTransferId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && investorTransferId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransferReviewAllocationTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorTransferReviewAllocationTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investorTransferReviewAllocationTableDataRetrieve>>>
export type InvestorTransferReviewAllocationTableDataRetrieveSuspenseQueryError = unknown

export const useInvestorTransferReviewAllocationTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof investorTransferReviewAllocationTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransferReviewAllocationTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorTransferReviewAllocationTableDataRetrieveSuspenseQueryOptions(fundFamilyId,investorTransferId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestorTransferReviewAllocationTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,investorTransferId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,investorTransferId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && investorTransferId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestorTransferReviewAllocationTableDataRetrieveQueryKey(fundFamilyId,investorTransferId),
              queryFn: () => investorTransferReviewAllocationTableDataRetrieve(fundFamilyId,investorTransferId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get table data to review the NAV summary for an investor transfer.
 */
export const investorTransferReviewNAVTableDataRetrieve = (
    fundFamilyId: string,
    investorTransferId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/review/nav-table/`, method: 'GET', signal
    },
      options);
    }
  

export const getInvestorTransferReviewNAVTableDataRetrieveQueryKey = (fundFamilyId: string,
    investorTransferId: string,) => {
    return [`/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/review/nav-table/`] as const;
    }

    
export const getInvestorTransferReviewNAVTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof investorTransferReviewNAVTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorTransferReviewNAVTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorTransferReviewNAVTableDataRetrieveQueryKey(fundFamilyId,investorTransferId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorTransferReviewNAVTableDataRetrieve>>> = ({ signal }) => investorTransferReviewNAVTableDataRetrieve(fundFamilyId,investorTransferId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && investorTransferId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investorTransferReviewNAVTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorTransferReviewNAVTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof investorTransferReviewNAVTableDataRetrieve>>>
export type InvestorTransferReviewNAVTableDataRetrieveQueryError = unknown

export const useInvestorTransferReviewNAVTableDataRetrieve = <TData = Awaited<ReturnType<typeof investorTransferReviewNAVTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorTransferReviewNAVTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorTransferReviewNAVTableDataRetrieveQueryOptions(fundFamilyId,investorTransferId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestorTransferReviewNAVTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investorTransferReviewNAVTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransferReviewNAVTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorTransferReviewNAVTableDataRetrieveQueryKey(fundFamilyId,investorTransferId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorTransferReviewNAVTableDataRetrieve>>> = ({ signal }) => investorTransferReviewNAVTableDataRetrieve(fundFamilyId,investorTransferId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && investorTransferId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransferReviewNAVTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorTransferReviewNAVTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investorTransferReviewNAVTableDataRetrieve>>>
export type InvestorTransferReviewNAVTableDataRetrieveSuspenseQueryError = unknown

export const useInvestorTransferReviewNAVTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof investorTransferReviewNAVTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransferReviewNAVTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorTransferReviewNAVTableDataRetrieveSuspenseQueryOptions(fundFamilyId,investorTransferId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestorTransferReviewNAVTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,investorTransferId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,investorTransferId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && investorTransferId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestorTransferReviewNAVTableDataRetrieveQueryKey(fundFamilyId,investorTransferId),
              queryFn: () => investorTransferReviewNAVTableDataRetrieve(fundFamilyId,investorTransferId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get table data to review the transaction summary for an investor transfer.
 */
export const investorTransferReviewTransactionTableDataRetrieve = (
    fundFamilyId: string,
    investorTransferId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/review/transactions-table/`, method: 'GET', signal
    },
      options);
    }
  

export const getInvestorTransferReviewTransactionTableDataRetrieveQueryKey = (fundFamilyId: string,
    investorTransferId: string,) => {
    return [`/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/review/transactions-table/`] as const;
    }

    
export const getInvestorTransferReviewTransactionTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof investorTransferReviewTransactionTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorTransferReviewTransactionTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorTransferReviewTransactionTableDataRetrieveQueryKey(fundFamilyId,investorTransferId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorTransferReviewTransactionTableDataRetrieve>>> = ({ signal }) => investorTransferReviewTransactionTableDataRetrieve(fundFamilyId,investorTransferId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && investorTransferId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investorTransferReviewTransactionTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorTransferReviewTransactionTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof investorTransferReviewTransactionTableDataRetrieve>>>
export type InvestorTransferReviewTransactionTableDataRetrieveQueryError = unknown

export const useInvestorTransferReviewTransactionTableDataRetrieve = <TData = Awaited<ReturnType<typeof investorTransferReviewTransactionTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorTransferReviewTransactionTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorTransferReviewTransactionTableDataRetrieveQueryOptions(fundFamilyId,investorTransferId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestorTransferReviewTransactionTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investorTransferReviewTransactionTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransferReviewTransactionTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorTransferReviewTransactionTableDataRetrieveQueryKey(fundFamilyId,investorTransferId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorTransferReviewTransactionTableDataRetrieve>>> = ({ signal }) => investorTransferReviewTransactionTableDataRetrieve(fundFamilyId,investorTransferId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && investorTransferId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransferReviewTransactionTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorTransferReviewTransactionTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investorTransferReviewTransactionTableDataRetrieve>>>
export type InvestorTransferReviewTransactionTableDataRetrieveSuspenseQueryError = unknown

export const useInvestorTransferReviewTransactionTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof investorTransferReviewTransactionTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    investorTransferId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorTransferReviewTransactionTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorTransferReviewTransactionTableDataRetrieveSuspenseQueryOptions(fundFamilyId,investorTransferId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestorTransferReviewTransactionTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,investorTransferId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,investorTransferId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && investorTransferId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestorTransferReviewTransactionTableDataRetrieveQueryKey(fundFamilyId,investorTransferId),
              queryFn: () => investorTransferReviewTransactionTableDataRetrieve(fundFamilyId,investorTransferId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get table data with the summary data for the transferor or transferee entities involved in a transfer
 */
export const transferInvestorEntitySummaryTableDataRetrieve = (
    fundFamilyId: string,
    investorTransferId: string,
    params?: TransferInvestorEntitySummaryTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/review/transferees-table/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getTransferInvestorEntitySummaryTableDataRetrieveQueryKey = (fundFamilyId: string,
    investorTransferId: string,
    params?: TransferInvestorEntitySummaryTableDataRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/review/transferees-table/`, ...(params ? [params]: [])] as const;
    }

    
export const getTransferInvestorEntitySummaryTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof transferInvestorEntitySummaryTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    investorTransferId: string,
    params?: TransferInvestorEntitySummaryTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transferInvestorEntitySummaryTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransferInvestorEntitySummaryTableDataRetrieveQueryKey(fundFamilyId,investorTransferId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof transferInvestorEntitySummaryTableDataRetrieve>>> = ({ signal }) => transferInvestorEntitySummaryTableDataRetrieve(fundFamilyId,investorTransferId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && investorTransferId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof transferInvestorEntitySummaryTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type TransferInvestorEntitySummaryTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof transferInvestorEntitySummaryTableDataRetrieve>>>
export type TransferInvestorEntitySummaryTableDataRetrieveQueryError = unknown

export const useTransferInvestorEntitySummaryTableDataRetrieve = <TData = Awaited<ReturnType<typeof transferInvestorEntitySummaryTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    investorTransferId: string,
    params?: TransferInvestorEntitySummaryTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transferInvestorEntitySummaryTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTransferInvestorEntitySummaryTableDataRetrieveQueryOptions(fundFamilyId,investorTransferId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTransferInvestorEntitySummaryTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof transferInvestorEntitySummaryTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    investorTransferId: string,
    params?: TransferInvestorEntitySummaryTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof transferInvestorEntitySummaryTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransferInvestorEntitySummaryTableDataRetrieveQueryKey(fundFamilyId,investorTransferId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof transferInvestorEntitySummaryTableDataRetrieve>>> = ({ signal }) => transferInvestorEntitySummaryTableDataRetrieve(fundFamilyId,investorTransferId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && investorTransferId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof transferInvestorEntitySummaryTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type TransferInvestorEntitySummaryTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof transferInvestorEntitySummaryTableDataRetrieve>>>
export type TransferInvestorEntitySummaryTableDataRetrieveSuspenseQueryError = unknown

export const useTransferInvestorEntitySummaryTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof transferInvestorEntitySummaryTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    investorTransferId: string,
    params?: TransferInvestorEntitySummaryTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof transferInvestorEntitySummaryTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTransferInvestorEntitySummaryTableDataRetrieveSuspenseQueryOptions(fundFamilyId,investorTransferId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getTransferInvestorEntitySummaryTableDataRetrieveLoader = (queryParamsOrFn?: (TransferInvestorEntitySummaryTableDataRetrieveParams | ((params: Params) => TransferInvestorEntitySummaryTableDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,investorTransferId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,investorTransferId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && investorTransferId) {
            return appQueryClient.prefetchQuery({
              queryKey: getTransferInvestorEntitySummaryTableDataRetrieveQueryKey(fundFamilyId,investorTransferId, queryParams),
              queryFn: () => transferInvestorEntitySummaryTableDataRetrieve(fundFamilyId,investorTransferId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Run an investor transfer.
 */
export const investorTransferDraftRun = (
    fundFamilyId: string,
    investorTransferId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<InvestorTransferReadData>(
      {url: `/fund-family/${fundFamilyId}/investor-transfer/${investorTransferId}/run/`, method: 'PUT'
    },
      options);
    }
  


export const getInvestorTransferDraftRunMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorTransferDraftRun>>, TError,{fundFamilyId: string;investorTransferId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investorTransferDraftRun>>, TError,{fundFamilyId: string;investorTransferId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investorTransferDraftRun>>, {fundFamilyId: string;investorTransferId: string}> = (props) => {
          const {fundFamilyId,investorTransferId} = props ?? {};

          return  investorTransferDraftRun(fundFamilyId,investorTransferId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestorTransferDraftRunMutationResult = NonNullable<Awaited<ReturnType<typeof investorTransferDraftRun>>>
    
    export type InvestorTransferDraftRunMutationError = unknown

    export const useInvestorTransferDraftRun = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorTransferDraftRun>>, TError,{fundFamilyId: string;investorTransferId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestorTransferDraftRunMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * List investor entities available for transfer.
 */
export const transferorInvestorEntityOptionsList = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<InvestorEntityDataList>(
      {url: `/fund-family/${fundFamilyId}/investor-transfer/transferor-investor-entity-options/`, method: 'GET', signal
    },
      options);
    }
  

export const getTransferorInvestorEntityOptionsListQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/investor-transfer/transferor-investor-entity-options/`] as const;
    }

    
export const getTransferorInvestorEntityOptionsListQueryOptions = <TData = Awaited<ReturnType<typeof transferorInvestorEntityOptionsList>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transferorInvestorEntityOptionsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransferorInvestorEntityOptionsListQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof transferorInvestorEntityOptionsList>>> = ({ signal }) => transferorInvestorEntityOptionsList(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof transferorInvestorEntityOptionsList>>, TError, TData> & { queryKey: QueryKey }
}

export type TransferorInvestorEntityOptionsListQueryResult = NonNullable<Awaited<ReturnType<typeof transferorInvestorEntityOptionsList>>>
export type TransferorInvestorEntityOptionsListQueryError = unknown

export const useTransferorInvestorEntityOptionsList = <TData = Awaited<ReturnType<typeof transferorInvestorEntityOptionsList>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transferorInvestorEntityOptionsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTransferorInvestorEntityOptionsListQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTransferorInvestorEntityOptionsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof transferorInvestorEntityOptionsList>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof transferorInvestorEntityOptionsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransferorInvestorEntityOptionsListQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof transferorInvestorEntityOptionsList>>> = ({ signal }) => transferorInvestorEntityOptionsList(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof transferorInvestorEntityOptionsList>>, TError, TData> & { queryKey: QueryKey }
}

export type TransferorInvestorEntityOptionsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof transferorInvestorEntityOptionsList>>>
export type TransferorInvestorEntityOptionsListSuspenseQueryError = unknown

export const useTransferorInvestorEntityOptionsListSuspense = <TData = Awaited<ReturnType<typeof transferorInvestorEntityOptionsList>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof transferorInvestorEntityOptionsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTransferorInvestorEntityOptionsListSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getTransferorInvestorEntityOptionsListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getTransferorInvestorEntityOptionsListQueryKey(fundFamilyId),
              queryFn: () => transferorInvestorEntityOptionsList(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      